import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import { useState, useEffect, useContext } from "react";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import IconButton from "@mui/material/IconButton";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import FormatAlignLeftIcon from "@mui/icons-material/FormatAlignLeft";
import AnimationIcon from "@mui/icons-material/Animation";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import logo from "../../assets/Images/hlogo.png";
import "./SideBar.css";
// import '../../Common.css'
import { NavLink } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Stack from "@mui/material/Stack";
import Switch from "@mui/material/Switch";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import ViewInArIcon from "@mui/icons-material/ViewInAr";
import LayersIcon from "@mui/icons-material/Layers";
import Badge from "@mui/material/Badge";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
// import btnprf from '../../../Images/btnprf.png'
// import { useTheme } from '@mui/material/styles';
import useMediaQuery from "@mui/material/useMediaQuery";
import Drawer from "@mui/material/Drawer";
import Popover from "@mui/material/Popover";
import LogoutIcon from "@mui/icons-material/Logout";
import Darkmode from "../DarkMode/Darkmode";
import { ThemeContext } from '../DarkMode/ThemeProvider';
import ExpandMore from "@mui/icons-material/ExpandMore";
import profile from '../../assets/Images/profile-img.png'
import { Link, useNavigate } from "react-router-dom";

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette.mode === 'dark' ? '#177ddc' : '#dfca6f',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
    boxSizing: 'border-box',
  },
}));


const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawers = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
}));

export default function Sidebar() {

  const theme = useTheme();
  const isLgup = useMediaQuery(theme.breakpoints.up('lg'));
  // const mobileUp = useMediaQuery(theme.breakpoints.up('sm'));
  const navigate = useNavigate()
  const [open, setOpen] = useState(true);
  // const { isLightMode, handleDarkmode } = useContext(ThemeContext);
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const loaction = useLocation()

  const activeFil = loaction.pathname.toLocaleLowerCase()

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const openPop = Boolean(anchorEl);
  const id = openPop ? 'simple-popover' : undefined;

  const [anchorEl2, setAnchorEl2] = React.useState(null);

  const handleClick2 = (event) => {
    setAnchorEl2(event.currentTarget);
  };

  const handleClose2 = () => {
    setAnchorEl2(null);
  };

  const openPop2 = Boolean(anchorEl2);
  const id2 = openPop2 ? 'simple-popover' : undefined;

  // useEffect(() => {
  //     setOpen(false);
  // }, [open]);

  useEffect(() => {
    if (!isLgup) {
      setOpen(false);
    }
  }, [isLgup]);


  const [expanded, setExpanded] = useState(null);

  const routes = [
    {
      name: "Dashboard",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="27"
          viewBox="0 0 28 27"
          fill="none"
        >
          <path
            d="M4.00244 13.4147C4.00244 13.1182 4.12021 12.8339 4.32983 12.6243C4.53945 12.4146 4.82377 12.2969 5.12022 12.2969H8.47355C8.77001 12.2969 9.05432 12.4146 9.26394 12.6243C9.47356 12.8339 9.59133 13.1182 9.59133 13.4147V20.1213C9.59133 20.4178 9.47356 20.7021 9.26394 20.9117C9.05432 21.1213 8.77001 21.2391 8.47355 21.2391H5.12022C4.82377 21.2391 4.53945 21.1213 4.32983 20.9117C4.12021 20.7021 4.00244 20.4178 4.00244 20.1213V13.4147ZM11.8269 13.4147C11.8269 13.1182 11.9447 12.8339 12.1543 12.6243C12.3639 12.4146 12.6482 12.2969 12.9447 12.2969H23.0047C23.3011 12.2969 23.5854 12.4146 23.7951 12.6243C24.0047 12.8339 24.1224 13.1182 24.1224 13.4147V20.1213C24.1224 20.4178 24.0047 20.7021 23.7951 20.9117C23.5854 21.1213 23.3011 21.2391 23.0047 21.2391H12.9447C12.6482 21.2391 12.3639 21.1213 12.1543 20.9117C11.9447 20.7021 11.8269 20.4178 11.8269 20.1213V13.4147Z"
            fill={activeFil === "/dashboard" ? "#009FF5" : "#373D4D"}
          />
          <path
            opacity="0.7"
            d="M23.0047 4.47266H5.12022C4.50289 4.47266 4.00244 4.9731 4.00244 5.59043V8.94377C4.00244 9.5611 4.50289 10.0615 5.12022 10.0615H23.0047C23.622 10.0615 24.1224 9.5611 24.1224 8.94377V5.59043C24.1224 4.9731 23.622 4.47266 23.0047 4.47266Z"
            fill={activeFil === "/dashboard" ? "#009FF5" : "#373D4D"}
          />
        </svg>
      ),
      path: "/dashboard",
    },
    {
      name: "Subadmin",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clip-rule="evenodd"
            d="M12.9446 9.68957C12.9446 10.7272 12.5324 11.7222 11.7987 12.4559C11.065 13.1896 10.0699 13.6018 9.03234 13.6018C7.99475 13.6018 6.99966 13.1896 6.26598 12.4559C5.5323 11.7222 5.12012 10.7272 5.12012 9.68957C5.12012 8.65198 5.5323 7.65689 6.26598 6.92321C6.99966 6.18952 7.99475 5.77734 9.03234 5.77734C10.0699 5.77734 11.065 6.18952 11.7987 6.92321C12.5324 7.65689 12.9446 8.65198 12.9446 9.68957ZM11.2679 9.68957C11.2679 10.2825 11.0324 10.8511 10.6131 11.2703C10.1939 11.6896 9.62525 11.9251 9.03234 11.9251C8.43943 11.9251 7.87081 11.6896 7.45156 11.2703C7.03231 10.8511 6.79678 10.2825 6.79678 9.68957C6.79678 9.09666 7.03231 8.52804 7.45156 8.10879C7.87081 7.68954 8.43943 7.45401 9.03234 7.45401C9.62525 7.45401 10.1939 7.68954 10.6131 8.10879C11.0324 8.52804 11.2679 9.09666 11.2679 9.68957ZM23.0046 11.3662C23.0046 12.2556 22.6513 13.1085 22.0224 13.7374C21.3935 14.3663 20.5406 14.7196 19.6512 14.7196C18.7619 14.7196 17.9089 14.3663 17.2801 13.7374C16.6512 13.1085 16.2979 12.2556 16.2979 11.3662C16.2979 10.4769 16.6512 9.62394 17.2801 8.99507C17.9089 8.3662 18.7619 8.0129 19.6512 8.0129C20.5406 8.0129 21.3935 8.3662 22.0224 8.99507C22.6513 9.62394 23.0046 10.4769 23.0046 11.3662ZM21.3279 11.3662C21.3279 11.8109 21.1512 12.2374 20.8368 12.5518C20.5224 12.8663 20.0959 13.0429 19.6512 13.0429C19.2065 13.0429 18.7801 12.8663 18.4656 12.5518C18.1512 12.2374 17.9746 11.8109 17.9746 11.3662C17.9746 10.9216 18.1512 10.4951 18.4656 10.1807C18.7801 9.86621 19.2065 9.68957 19.6512 9.68957C20.0959 9.68957 20.5224 9.86621 20.8368 10.1807C21.1512 10.4951 21.3279 10.9216 21.3279 11.3662Z"
            fill={activeFil === "/applicant3" ? "#009FF5" : "#373D4D"}
          />
          <path
            d="M3.72256 21.4272C3.72257 20.1673 4.22307 18.959 5.11397 18.0681C6.00487 17.1772 7.21319 16.6767 8.47312 16.6767H9.5909C10.8508 16.6767 12.0591 17.1772 12.95 18.0681C13.841 18.959 14.3415 20.1673 14.3415 21.4272H16.0181C16.0181 20.4637 16.4009 19.5397 17.0821 18.8585C17.7634 18.1772 18.6874 17.7944 19.6509 17.7944C20.6144 17.7944 21.5384 18.1772 22.2197 18.8585C22.9009 19.5397 23.2837 20.4637 23.2837 21.4272H24.9603C24.9605 20.2938 24.5979 19.1901 23.9257 18.2775C23.2535 17.365 22.3069 16.6915 21.2244 16.3556C20.1419 16.0197 18.9803 16.039 17.9096 16.4108C16.8388 16.7825 15.9152 17.4871 15.2737 18.4215C14.7271 17.3884 13.9091 16.5239 12.9078 15.921C11.9065 15.3181 10.7597 14.9997 9.5909 15H8.47312C6.76852 15 5.13373 15.6772 3.92839 16.8825C2.72305 18.0878 2.0459 19.7226 2.0459 21.4272H3.72256Z"
            fill={activeFil === "/applicant3" ? "#009FF5" : "#373D4D"}
          />
        </svg>
      ),
      //   path: "/subadmin",
      children: [
        { name: "Subadmin", path: "/subadmin" },
        { name: "Add Subadmin", path: "/addsubadmin" },
      ],
      icon: <ExpandMore />,
    },
    {
      name: "Category",
      svg: <LayersIcon />,
      path: "/productlist",
    },
    {
      name: "Attributes",
      svg: <ViewInArIcon />,
      path: "/attributes",
    },

    {
      name: "Order",
      svg: <BookmarkBorderIcon />,
      //   path: "/order",
      children: [
        { name: "Order", path: "/order" },
        { name: "Order Tracking", path: "/ordertrack" },
      ],
      icon: <ExpandMore />,
    },
    {
      name: "Support",
      svg: <SupportAgentIcon />,
      path: "/support",
    },
    {
      name: "Components",
      svg: <AnimationIcon />,
      path: "/component",
    },
  ];

  const drawer = (
    <>

      <DrawerHeader className='drawhead'>
        <div onClick={(() => { navigate('/') })} className='cursor'>
          {/* {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />} */}
          <div className="apxlogo">
            <img src={logo} alt="apx" />
          </div>

        </div>
      </DrawerHeader>

      <List className="listmui">
        {routes.map((row, index) => (
          <div key={index}>
            <ListItem
              disablePadding
              sx={{ display: "block" }}
              className="routelist"
            // Don't use 'component="a"' — let NavLink handle it
            >
              <ListItemButton
                component={NavLink}
                to={row.path}
                onClick={() => {
                  if (row.children) {
                    setExpanded(expanded === index ? null : index);
                  } else {
                    setOpen(false);
                    setExpanded(null);
                  }
                }}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
                className="icobtn"
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  {row.svg}
                </ListItemIcon>
                <ListItemText
                  className="routetext"
                  primary={row.name}
                  sx={{ opacity: open ? 1 : 0 }}
                />
                <ListItemIcon style={{ justifyContent: "end" }}>
                  {row.icon}
                </ListItemIcon>
              </ListItemButton>
            </ListItem>

            {/* Render Dropdown */}
            {row.children && expanded === index && (
              <List component="div" disablePadding>
                {row.children.map((child, childIndex) => (
                  <ListItem
                    key={childIndex}
                    disablePadding
                    sx={{ pl: open ? 4 : 2 }}
                    className="child-routelist"
                  >
                    <ListItemButton
                      component={NavLink}
                      to={child.path}
                      onClick={() => setOpen(false)}
                    >
                      <ListItemText
                        primary={child.name}
                        className="drop-list"
                      />
                    </ListItemButton>
                  </ListItem>
                ))}
              </List>
            )}
          </div>
        ))}
      </List>


    </>
  )

  const darkMode = (
    <div className="text-center">
      <Darkmode />
    </div>


  );

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar position="fixed" open={open} className='sidetoolbar' sx={{ width: !isLgup ? '100%' : 'calc(100%-200px)' }}>
        <Toolbar sx={{ justifyContent: "space-between" }}>
          {!isLgup ? (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={open ? handleDrawerClose : handleDrawerOpen}
              sx={{ mr: 2 }}
            >
              {open ? <MenuOpenIcon /> : <FormatAlignLeftIcon />}
              {/* <MenuIcon sx={{ fill: '#000' }} /> */}
            </IconButton>
          ) : (
            <div
              color="inherit"
              aria-label="open drawer"
              onClick={open ? handleDrawerClose : handleDrawerOpen}
              edge="start"
              sx={{
                marginRight: 5,
              }}
            >
              <div className="apxlogo cursor">
                {open ? <MenuOpenIcon /> : <FormatAlignLeftIcon />}
              </div>
            </div>
          )}

          <Stack direction="row" spacing={4} sx={{ alignItems: "center" }}>
            <div className="display-4 padding-10">
              <div className="">
                <button
                  class="Btn"
                  onClick={() => {
                    navigate("/");
                  }}
                >
                  <div class="sign">
                    <LogoutIcon />
                  </div>

                  <div class="text">Logout</div>
                </button>
              </div>
            </div>

            <List>{darkMode}</List>

            <Badge badgeContent={4} color="error">
              <NotificationsOutlinedIcon
                color="action"
                className="cursor bell-icon"
                onClick={handleClick2}
              />
            </Badge>
            <Popover
              id={id2}
              open={openPop2}
              anchorEl={anchorEl2}
              onClose={handleClose2}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              className="popover-paper"
            >
              <div
                className="popover-box"
                style={{
                  padding: "16px",
                  borderRadius: "10px",
                  width: "300px",
                  height: "200px",
                }}
              >
                <div className="cursor noti-drop">
                  <h4>Message</h4>
                  <div className="display-1 mt-10" style={{ alignItems: 'flex-start' }}>

                    <div className="notify-img">
                      <img src={profile} alt="message" />
                    </div>
                    <div>
                      <Link to={''}>Cameron Williamson</Link>
                      <p style={{ margin: '0px' }}>Hi</p>
                    </div>
                  </div>
                  <div className="display-1 mt-10" style={{ alignItems: 'flex-start' }}>

                    <div className="notify-img">
                      <img src={profile} alt="user" />
                    </div>
                    <div>
                      <Link to={''}>Cameron Williamson</Link>
                      <p style={{ margin: '0px' }}>Hi</p>
                    </div>
                  </div>
                </div>
              </div>
            </Popover>
            {/* <Avatar onClick={handleClick} alt="Remy Sharp" src={btnprf} sx={{ width: 32, height: 32 }} className='cursor' /> */}
            <Popover
              id={id}
              open={openPop}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
            >
              <div
                className=""
                style={{ padding: "15px", borderRadius: "10px" }}
              >


                <div
                  className="display-1 margin-t-10px cursor"
                  onClick={() => {
                    navigate("/login");
                  }}
                >
                  <LogoutIcon />
                  <div className="hlp">Log out</div>
                </div>
              </div>
            </Popover>
          </Stack>
        </Toolbar>
      </AppBar>

      {
        isLgup ? <Drawers
          variant={"permanent"}
          open={open}
        // onClose={handleDrawerClose}

        >
          {drawer}
        </Drawers> : <Drawer
          variant={"temporary"}
          open={open}
        // onClose={handleDrawerClose}

        >
          {drawer}
        </Drawer>
      }
      {/* <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
                <DrawerHeader />

            </Box> */}
    </Box >
  );
}
